import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';

import { LegalPage } from '../../../features/marketing/pages/LegalPage';

export const Route = createFileRoute('/$lang/legal/imprint')({ component: Page });

function Page(): ReactNode {
  const { lang } = Route.useParams();
  return <LegalPage lang={lang} doc="imprint" />;
}
